<template>
	<div class="container">
		<div class="content">
			<div class="card mh_700 mb_0">
				<h3 class="title mb_20">{{ $t('cs.faq') }}</h3>
				<div class="faq_border_top">
					<accordion v-for="item in faqList" :key="item.seq" class="faq">
						<accordion-item>
							<template v-slot:accordion-trigger>
								<p class="question">{{ item.title }}</p>
								<span class="accordion_trigger_icon"></span>
							</template>

							<template v-slot:accordion-content>
								<p class="answer" v-html="item.content"></p>
							</template>
						</accordion-item>
					</accordion>
				</div>

				<pagination
					:totalCount="pageNavigation.total_count"
					:totalPage="pageNavigation.total_page"
					:curPage="pageNavigation.cur_page"
					:point="pageNavigation.point"
					:firstPage="pageNavigation.first_page"
					:lastPage="pageNavigation.last_page"
					@change="pageChangeHandler"
				></pagination>
			</div>
		</div>
	</div>
</template>

<script>
import Accordion from '@/components/Layout/Accordion';
import AccordionItem from '@/components/Layout/AccordionItem';
import pagination from '@/components/Pagination';
import { fetchFaqList } from '@/api/cs';
import { commonError } from '@/common/dialog';

export default {
	name: 'Faq',
	components: {
		Accordion,
		AccordionItem,
		pagination,
	},
	data() {
		return {
			faqList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadFaqList();
		},
		async loadFaqList() {
			const params = {
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchFaqList(params).catch(
				commonError,
			);
			this.faqList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadNoticeList();
		},
	},
};
</script>
